// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React from 'react'
import './AccountSettingsSection.scss'
import { SecondaryButton } from '../../../components/ui_kit_quickMD/secondary-button/secondarybutton'
import lockIcon from '../../../images/common/lock.png'

export const AccountSettingsSection = ({
  className = '',
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  style,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  children,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  title,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  onClickEdit,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  isWithLockIcon,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  isWithEditBtn,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  editModeBtnHandler,
}) => {
  const secondaryBtnContainerStyle = {
    height: 38,
    width: 55,
    border: '1px solid #00A2B2',
    padding: 0,
    position: 'relative',
  }
  const secondarySectionLabelStyle = {
    fontSize: 18,
    fontWeight: 400,
    letterSpacing: 1.2,
  }
  const accountSettingsSectionMainWrapperStyle = { marginTop: isWithEditBtn ? 38 : 44, ...style }
  const accountSettingsSectionHeaderStyle = { marginBottom: isWithEditBtn ? 12 : 16 }
  const accountSettingsSectionTitleWrapperStyle = {
    justifyContent: isWithEditBtn ? 'space-between' : 'flex-start',
  }

  return (
    <div
      className={`account-settings-section-main-wrapper ${className}`}
      style={accountSettingsSectionMainWrapperStyle}>
      <div className='account-settings-section-header' style={accountSettingsSectionHeaderStyle}>
        <div className='account-settings-section-title-wrapper' style={accountSettingsSectionTitleWrapperStyle}>
          <div className='account-settings-section-text account-settings-section-title'>{title}</div>
          {isWithEditBtn ?
            // @ts-expect-error TS2739 -- MIGRATION: not approved, fix when encountered
            <SecondaryButton
              btnText='Edit'
              containerStyle={secondaryBtnContainerStyle}
              labelStyle={secondarySectionLabelStyle}
              onPress={editModeBtnHandler}
            />
          : null}
          {isWithLockIcon ?
            <img className='account-settings-section-lock-icon' src={lockIcon} alt='lockIcon' />
          : null}
        </div>
        {onClickEdit ?
          <div onClick={onClickEdit}>Edit</div>
        : null}
      </div>
      <div className='account-settings-section-content-container'>{children}</div>
    </div>
  )
}
